import { Layer } from '@fluentui/react';
import AppContext from 'App/AppContext';
import { IPProgressIndicator } from 'baseComponents/ProgressIndicator/IPProgressIndicator';
import { useContext } from 'react';

const progressBarStyles = {
  root: {
    paddingTop: 0,
  },
  itemProgress: {
    paddingTop: 0,
  },
};

const ContentLoader = () => {
  const appContext = useContext(AppContext);

  if (appContext.isContentLoading) {
    return (
      <Layer hostId="layerHostContentAreaTop">
        <IPProgressIndicator barHeight={3} styles={progressBarStyles}></IPProgressIndicator>
      </Layer>
    );
  } else {
    return null;
  }
};

export default ContentLoader;
